import { formatDateWithLetterMonth } from '@/utils/date.utils';
import { getFormattedTime } from '@/utils/date.utils';
import { TFunction } from 'i18next';

interface DateIndicationProps {
  t?: TFunction<undefined>;
  label?: string;
  date?: string;
}

export const DateIndication = ({ t, label, date }: DateIndicationProps) => {
  const dateLabel = label ?? t('common:lastUpdate');

  return (
    <div className="bg-gray-200 rounded-lg px-3 pt-2.5 pb-1.5 flex gap-2.5 max-sm:w-full max-sm:justify-center">
      <i className="-mt-1.25 ki-outline ki-calendar text-primary text-lg" />
      <div className="text-gray-700 text-sm">
        <span className="font-medium">
          {dateLabel}
          <span className="mx-1">:</span>
        </span>
        {`${formatDateWithLetterMonth({
          dateString: date ?? new Date().toISOString(),
          monthAbbreviated: false,
        })} ${t('common:at').toLowerCase()} ${getFormattedTime(
          date ?? new Date().toISOString(),
        )}`}
      </div>
    </div>
  );
};
